module.exports = __webpack_public_path__ + "static/cercamappa_italia-135dada41b6d1503ebbf000e10465424.jpg";